import { axiosRequest } from '../../axiosRequest';
import { AUDIENCE_TYPES } from 'helpers/notificationDelivery';

import moment from 'moment';

const adapterAppResponse = ({ data, success }) => {
	if (success === false) return { error: true, data };

	const notifications = Array.isArray(data?.notifications)
		? data?.notifications?.map((i) => {
				let notification = {
					id: i?.id,
					title: i?.title,
					message: i?.message,
					audience: i?.audience,
					audience_type: i?.audience_type || AUDIENCE_TYPES.VENUES,
					total_recipients: i?.total_recipients ?? 0,
					// The list only returns a compact summary of the delivery.
					stats: {
						delivered: i?.stats?.delivered ?? 0,
						failed: i?.stats?.failed ?? 0,
					},
					status: i?.status,
					sent_at:
						i?.sent_at && moment(i?.sent_at, 'YYYY-MM-DD').format('MM/DD/YYYY'),
					created_at:
						i?.created_at &&
						moment(i?.created_at, 'YYYY-MM-DD').format('MM/DD/YYYY'),
					updated_at:
						i?.updated_at &&
						moment(i?.updated_at, 'YYYY-MM-DD').format('MM/DD/YYYY'),
					admin: {
						id: i.admin.id,
						full_name: i.admin.full_name,
					},
				};
				return notification;
		  })
		: [];

	return notifications;
};

export const getNotificationsList = async (value) => {
	var options = {
		method: 'get',
		url: 'dashboard/notifications',
		query: {
			status: value,
		},
	};

	if (!value) delete options.query;

	const response = await axiosRequest(options);

	const notifications = adapterAppResponse(response);

	return notifications;
};
